import React from 'react';
import { UI_TEXT, SUGGESTIONS, CONTACT, NOTES } from '../config';

const WelcomeSection = ({ onSuggestionClick }) => {
  return (
    <div className="welcome-section">
      <div className="welcome-hero">
        <p className="eyebrow">AI ENGINEER · BENGALURU</p>
        <h1>{UI_TEXT.TITLE}</h1>
        <p className="subtitle">{UI_TEXT.SUBTITLE}</p>
      </div>

      <div className="suggestions">
        <div className="suggestion-chips">
          {SUGGESTIONS.map((suggestion, idx) => (
            <button
              key={idx}
              className="suggestion-chip"
              onClick={() => onSuggestionClick(suggestion)}
            >
              {suggestion}
            </button>
          ))}
        </div>
        <p className="welcome-links">
          <a href={CONTACT.gitHub} target="_blank" rel="noopener noreferrer">GitHub</a>
          <span className="link-sep">·</span>
          <a href={CONTACT.linkedIn} target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <span className="link-sep">·</span>
          <a href={`mailto:${CONTACT.email}`}>Email</a>
          <span className="link-sep">·</span>
          <a href={NOTES.URL}>Notes</a>
        </p>
      </div>
    </div>
  );
};

export default WelcomeSection;
